import { render, staticRenderFns } from "./SituationsRegister.vue?vue&type=template&id=01bab6e5&scoped=true"
import script from "./SituationsRegister.vue?vue&type=script&lang=js"
export * from "./SituationsRegister.vue?vue&type=script&lang=js"
import style0 from "./SituationsRegister.vue?vue&type=style&index=0&id=01bab6e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bab6e5",
  null
  
)

export default component.exports